<template>
  <div :id="sectionId" v-if="excursionItems.length > 0">
    <div uk-slider="center: true">
      <h3 class="AppTitle">{{title}}</h3>
      <div class="uk-position-relative">
        <div class="uk-slider-container">
          <ul class="uk-slider-items uk-child-width-1-3@m uk-grid">
            <li v-for="(item, index) in excursionItems" :key="index">
              <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                  <img :src="`${ASSETS_BASE_URL}${item.img_path}`" alt="">
                </div>
                <div class="uk-card-body">
                  <h3 class="uk-card-title">{{item.title}}</h3>
                  <div>
                    <a class="uk-button uk-button-secondary" :href="`#modal-full-${propertyId}-${id}`" uk-toggle
                       @click="selectedItem = item">{{'view_more'|translate}}</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-hidden@s uk-light">
          <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
        </div>
        <div class="uk-visible@s">
          <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next
             uk-slider-item="next"></a>
        </div>
      </div>
      <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
    </div>
    <div :id="`modal-full-${propertyId}-${id}`" class="uk-modal-full" uk-modal ref="excursionModal">
      <div class="uk-modal-dialog" v-if="selectedItem">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid>
          <div class="uk-background-cover"
               :style="{ backgroundImage: `url(${ASSETS_BASE_URL}${selectedItem.img_path})`}"
               uk-height-viewport></div>
          <div class="uk-padding-large">
            <h1>{{selectedItem.title}}</h1>
            <p>{{selectedItem.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store'

export default {
  name: 'ExcursionSliderComponent',
  props: ['sectionId', 'title', 'propertyId'],
  data: function () {
    return {
      selectedItem: null,
      id: new Date().getTime()
    }
  },
  mounted () {
    this.fetchExcursions()
  },
  methods: {
    fetchExcursions () {
      this.$store.dispatch('excursions/fetchPropertyExcursions', { propertyId: this.propertyId })
    }
  },
  computed: {
    excursionItems: function () {
      return store.getters['excursions/propertyExcursions'][`property_${this.propertyId}`]
    }
  },
  beforeDestroy () {
    if (this.$refs.excursionModal) {
      // eslint-disable-next-line
      UIkit.modal(this.$refs.excursionModal).hide()
    }
  }
}
</script>

<style scoped>
  .uk-card-media-top {
    min-height: 280px;
    max-height: 280px;
    overflow-y: hidden;
  }

  .uk-card-title {
    font-size: 18px;
  }
</style>
